/**
 * Announcement TTS voice type class
 */
export default class {
  constructor (data) {
    this.name = data.name
    this.languageCodes = data.language_codes
    this.ssmlGender = data.ssml_gender
  }
}
